// Product accent themes (presentation only — independent of light/dark display mode).
export const THEME_STORAGE_KEY = 'bodymax-accent-theme';
export const DEFAULT_THEME_ID = 'blue';

// Each theme: { id, label, accentHex, onAccent, thumb, background, overlay? }
// `overlay` is optional — omit it to use DEFAULT_BACKDROP_OVERLAY below.
export const THEMES = [
  {
    id: 'original',
    label: 'Neon Lime',
    accentHex: '#CCFF00',
    onAccent: '#000000',
    thumb: '/themes/original-thumb.webp',
    background: '/themes/original-bg.webp',
  },
  {
    id: 'green',
    label: 'Carbon Green',
    accentHex: '#22C55E',
    onAccent: '#000000',
    thumb: '/themes/green-thumb.webp',
    background: '/themes/green-bg.webp',
  },
  {
    id: 'blue',
    label: 'Carbon Blue',
    accentHex: '#0096FC',
    onAccent: '#FFFFFF',
    thumb: '/themes/blue-thumb.webp',
    background: '/themes/blue-bg.webp',
  },
  {
    id: 'red',
    label: 'Carbon Red',
    accentHex: '#DC143C',
    onAccent: '#FFFFFF',
    thumb: '/themes/red-thumb.webp',
    background: '/themes/red-bg.webp',
  },
  {
    id: 'pink',
    label: 'Carbon Pink',
    accentHex: '#FA1E8C',
    onAccent: '#FFFFFF',
    thumb: '/themes/pink-thumb.webp',
    background: '/themes/pink-bg.webp',
  },
  {
    id: 'carbon',
    label: 'Carbon White',
    accentHex: '#FFFFFF',
    onAccent: '#000000',
    thumb: '/themes/carbon-thumb.webp',
    background: '/themes/carbon-bg.webp',
    overlay: 'linear-gradient(180deg, rgba(10,10,10,0.45) 0%, rgba(10,10,10,0.50) 45%, rgba(10,10,10,0.82) 100%)',
  },
];

export const getTheme = (id) => THEMES.find(t => t.id === id) || THEMES[0];

// Scrim painted over a theme's background image. Themes may override via `overlay`.
export const DEFAULT_BACKDROP_OVERLAY =
  'linear-gradient(180deg, rgba(10,10,10,0.68) 0%, rgba(10,10,10,0.82) 45%, rgba(10,10,10,0.94) 100%)';

// Runtime readers for contexts that cannot use CSS variables (canvas, confetti).
const readVar = (name, fallback) => {
  try {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  } catch (e) {
    return fallback;
  }
};

export const readAccentHex = () => readVar('--accent-hex', '#CCFF00');
export const readAccentRgb = () => readVar('--accent-rgb', '204, 255, 0');
